<template>
    <NegociosShell>
        <section class="sp-section sp-legal">
            <div class="sp-container">
                <div class="sp-legal__head">
                    <span class="sp-eyebrow">Legal</span>
                    <h1 class="sp-h2">{{ doc.titulo }}</h1>
                    <p class="sp-lead">{{ doc.intro }}</p>
                </div>

                <p class="sp-legal__aviso">
                    <i class="pi pi-info-circle" aria-hidden="true"></i>
                    <span>
                        Este documento recoge el marco de tratamiento de datos del servicio. El
                        texto definitivo está pendiente de aprobación del área legal de Seway
                        Plus; cualquier duda puede consultarse en
                        <a href="mailto:directorcomercial@setic.co">directorcomercial@setic.co</a>.
                    </span>
                </p>

                <article class="sp-legal__cuerpo">
                    <section v-for="bloque in doc.bloques" :key="bloque.titulo">
                        <h2 class="sp-h3">{{ bloque.titulo }}</h2>
                        <p v-for="(parrafo, i) in bloque.parrafos" :key="i">{{ parrafo }}</p>
                    </section>
                </article>

                <router-link to="/negocios" class="sp-btn sp-btn--outline sp-legal__volver">
                    <i class="pi pi-arrow-left" aria-hidden="true"></i>
                    <span>Volver a Seway Plus Negocios</span>
                </router-link>
            </div>
        </section>
    </NegociosShell>
</template>

<script>
import NegociosShell from './NegociosShell';
import { aplicarSeo, limpiarSeo } from './seo';

const PRIVACIDAD = {
    titulo: 'Política de privacidad',
    intro:
        'Cómo trata Seway Plus la información personal de anunciantes y conductores en el servicio de publicidad en ruta.',
    bloques: [
        {
            titulo: 'Responsable del tratamiento',
            parrafos: [
                'El responsable del tratamiento de los datos recolectados a través de este sitio es SETIC S.A.S., con domicilio en CLL. 85 # 48-01, Itagüí, Antioquia, Colombia, correo directorcomercial@setic.co y teléfono (+57) 316 471 1351.'
            ]
        },
        {
            titulo: 'Datos que recolectamos en esta página',
            parrafos: [
                'Del formulario de contacto recolectamos únicamente el nombre, el nombre del negocio, el correo electrónico, el número de celular y el mensaje que el interesado escribe de forma voluntaria.',
                'Estos datos se usan exclusivamente para responder la solicitud, explicar el servicio de publicidad y, si el interesado lo autoriza, acompañar el registro de su negocio. No se ceden a terceros con fines comerciales.'
            ]
        },
        {
            titulo: 'Información que reciben los anunciantes',
            parrafos: [
                'Seway Plus entrega a los anunciantes únicamente métricas agregadas y anónimas sobre el desempeño de sus campañas, como el número de veces que se mostró una oferta y el interés que generó.',
                'En ningún caso se entregan a los anunciantes datos personales de los conductores, ni su identidad, ni su ubicación, ni su recorrido, ni ningún dato que permita identificarlos de forma directa o indirecta.'
            ]
        },
        {
            titulo: 'Ubicación de los conductores',
            parrafos: [
                'La información de ubicación se procesa dentro de la plataforma con la única finalidad de determinar qué ofertas pueden resultar útiles para el conductor durante su viaje. El área de cobertura de cada sede la define Seway Plus, no el comercio anunciante.',
                'Las imágenes de mapas y de la aplicación que aparecen en esta página son ilustrativas y no representan ubicaciones, rutas ni conductores reales.'
            ]
        },
        {
            titulo: 'Derechos del titular',
            parrafos: [
                'Conforme a la Ley 1581 de 2012 y sus decretos reglamentarios, el titular de los datos puede conocer, actualizar y rectificar su información, solicitar prueba de la autorización otorgada, ser informado sobre el uso dado a sus datos, revocar la autorización y solicitar la supresión de sus datos cuando proceda.',
                'Para ejercer estos derechos puede escribir a directorcomercial@setic.co indicando su solicitud y un medio de contacto.'
            ]
        },
        {
            titulo: 'Conservación y seguridad',
            parrafos: [
                'Los datos se conservan mientras exista una relación comercial o el interés manifestado siga vigente, y se protegen con medidas técnicas y administrativas razonables para evitar accesos no autorizados, pérdida o alteración.'
            ]
        }
    ]
};

const TERMINOS = {
    titulo: 'Términos y condiciones',
    intro:
        'Condiciones de uso del sitio público de Seway Plus Negocios y del servicio de publicidad para comercios.',
    bloques: [
        {
            titulo: 'Objeto',
            parrafos: [
                'Seway Plus Negocios es un servicio de publicidad que permite a comercios aliados mostrar ofertas dentro de la aplicación que utilizan los conductores de carga, asociadas al área de cobertura definida para cada sede.'
            ]
        },
        {
            titulo: 'Carácter informativo de este sitio',
            parrafos: [
                'La información publicada en esta página tiene fines informativos y comerciales. Las imágenes de la aplicación, los mapas, los comercios y las ofertas mostradas son ilustrativas y no corresponden a establecimientos, rutas ni conductores reales.',
                'Desde esta página no se realiza ninguna compra ni contratación. La activación de campañas se completa desde el portal de anunciantes, previa creación de la cuenta.'
            ]
        },
        {
            titulo: 'Tarifas',
            parrafos: [
                'Los valores publicados corresponden al precio por día de campaña por sede y son los vigentes al momento de la consulta. Seway Plus puede actualizarlos; el valor aplicable a una campaña será el informado al momento de contratarla.'
            ]
        },
        {
            titulo: 'Contenido publicado por el anunciante',
            parrafos: [
                'El anunciante es responsable de la veracidad, legalidad y vigencia de las ofertas, fotos, descuentos y horarios que publique, así como de honrar las condiciones ofrecidas a los conductores.',
                'Seway Plus puede rechazar o retirar contenidos que resulten engañosos, ilegales, ofensivos o que puedan afectar la seguridad vial.'
            ]
        },
        {
            titulo: 'Seguridad vial',
            parrafos: [
                'El servicio se diseña bajo el principio de no interferir con la conducción segura. Las ofertas se presentan de manera que el conductor pueda consultarlas sin comprometer su atención en la vía.'
            ]
        },
        {
            titulo: 'Protección de datos',
            parrafos: [
                'El tratamiento de datos personales se rige por la política de privacidad de este sitio y por la Ley 1581 de 2012.'
            ]
        }
    ]
};

export default {
    name: 'PaginaLegal',
    components: { NegociosShell },
    computed: {
        doc() {
            return this.$route.path === '/terminos-condiciones' ? TERMINOS : PRIVACIDAD;
        }
    },
    watch: {
        // Permite alternar entre los dos documentos sin recargar el componente
        doc: {
            handler() {
                this.aplicar();
            }
        }
    },
    mounted() {
        this.aplicar();
    },
    unmounted() {
        limpiarSeo();
    },
    methods: {
        aplicar() {
            aplicarSeo({
                titulo: this.doc.titulo + ' | Seway Plus Negocios',
                descripcion: this.doc.intro
            });
            window.scrollTo({ top: 0 });
        }
    }
};
</script>

<style lang="scss" scoped>
.sp-legal {
    background: var(--sp-surface);
}

.sp-legal__head {
    max-width: 80ch;
    margin-bottom: 1.75rem;
}

.sp-legal__aviso {
    display: flex;
    align-items: flex-start;
    gap: 0.7rem;
    max-width: 80ch;
    padding: 1rem 1.15rem;
    background: var(--sp-orange-50);
    border-left: 4px solid var(--sp-orange);
    border-radius: 0 10px 10px 0;
    color: var(--sp-navy);
    font-size: 0.88rem;

    i {
        flex: 0 0 auto;
        margin-top: 0.15rem;
        color: var(--sp-orange);
    }

    a {
        color: var(--sp-orange);
        font-weight: 600;
        text-decoration: underline;
        overflow-wrap: anywhere;
    }
}

.sp-legal__cuerpo {
    max-width: 80ch;
    margin-top: 2rem;

    section + section {
        margin-top: 1.85rem;
    }

    h2 {
        margin-bottom: 0.6rem;
    }

    p {
        color: var(--sp-text-soft);
        font-size: 0.95rem;
        line-height: 1.75;
    }

    p + p {
        margin-top: 0.7rem;
    }
}

.sp-legal__volver {
    margin-top: 2.5rem;
}
</style>
